<template>
  <div id="wishlist">
    <CdrText v-if="ownedList || emptyList" class="list__text"> ({{ itemsLength }}) </CdrText>
    <CdrTable v-if="emptyList" full-width class="list__table">
      <thead class="list__table-header">
        <tr>
          <th id="head1" scope="col">Product</th>
          <th id="head2" scope="col">Quantity</th>
          <th id="head3" scope="col">Price</th>
        </tr>
      </thead>
      <transition-group tag="tbody" name="list-body">
        <WishlistDetailItemComponent
          v-for="product in pageEntries"
          :key="product.id"
          :user-logged-in="userLoggedIn"
          :owned-list="ownedList"
          :product-info="product"
          :user-wishlists="userWishlists"
          :new-global-nav="newGlobalNav"
          :modal-status="modalStatus"
          class="list-body-item"
        />
      </transition-group>
    </CdrTable>
    <PaginatorComponent />
    <div>
      <CdrText v-if="!emptyList && ownedList" class="list__text">
        There are {{ itemsLength }} in this list.
        {{ `${categoriesList ? 'Here are categories to get you started:' : ''}` }}
      </CdrText>
      <CdrText v-if="!emptyList && !ownedList" class="list__text"> There are {{ itemsLength }} in this list. </CdrText>
      <CdrList v-if="userLoggedIn && ownedList && !emptyList" class="list__categories" modifier="compact unordered">
        <li v-for="(category, index) in categoriesList" :key="`category-${index}`">
          <CdrButton
            class="wishlist-categoryLink"
            :data-ui="`wishlist-categoryLink-${index}`"
            modifier="link"
            tag="a"
            :href="category.target"
            @click="handleCategory"
          >
            {{ category.text }}
          </CdrButton>
        </li>
      </CdrList>
    </div>
    <ModalContainer />
  </div>
</template>

<script>
import { CdrTable, CdrText, CdrButton, CdrList } from '@rei/cedar';
import { mapStores, mapState } from 'pinia';

import WishlistDetailItemComponent from './WishlistDetailItemComponent.vue';
import PaginatorComponent from '../common/PaginatorComponent.vue';
import ModalContainer from '../modals/ModalContainer.vue';
import metrics from '../../utils/metrics';
import { useWishlistStore } from '../../stores';

export default {
  name: 'WishlistDetailComponent',
  components: {
    WishlistDetailItemComponent,
    PaginatorComponent,
    CdrTable,
    CdrText,
    CdrButton,
    CdrList,
    ModalContainer,
  },
  props: {
    userLoggedIn: {
      type: Boolean,
      required: true,
    },
    ownedList: {
      type: Boolean,
      required: true,
    },
    wishlistItemsLists: {
      type: Object,
      required: true,
    },
    userWishlists: {
      type: Array,
      default: () => [],
    },
    categoriesList: {
      type: Array,
      default: () => [],
    },
    newGlobalNav: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapStores(useWishlistStore),
    ...mapState(useWishlistStore, ['addToCartState']),
    pageEntries() {
      return this.wishlistStore.wishlistPageEntries;
    },
    modalStatus() {
      return !!this.addToCartState.modalIsOpen;
    },
    emptyList() {
      return this.wishlistStore.wishlistEntries ? this.wishlistStore.wishlistEntries.length > 0 : false;
    },
    itemsLength() {
      let itemsNumber =
        !!this.wishlistStore.wishlistEntries && this.wishlistStore.wishlistEntries.length > 0
          ? this.wishlistStore.wishlistEntries.map((e) => e.quantity).reduce((a, b) => a + b)
          : 0;
      itemsNumber = this.wishlistStore.itemRemovedMoved.item && itemsNumber > 0 ? itemsNumber - 1 : itemsNumber;
      if (itemsNumber === 1) {
        return '1 item';
      }
      return `${itemsNumber} items`;
    },
  },
  methods: {
    handleCategory() {
      metrics.metricsClick(this.category.text);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@rei/cdr-tokens/dist/rei-dot-com/scss/cdr-tokens';
.list {
  &__text {
    display: block;
    margin-top: $cdr-space-one-x;
    margin-bottom: $cdr-space-one-x;
  }

  &__table {
    &-header {
      display: none;
    }

    tbody {
      border: 0;
    }
  }

  &__categories {
    display: block;
    margin-left: $cdr-space-two-x;
    font-weight: bolder;

    li {
      display: block;

      a {
        font-weight: lighter;
        padding-left: 0;
        text-decoration: none;
      }
    }
  }
}

.list-body-enter-active,
.list-body-leave-active {
  transition: opacity 0.7s ease-out;
}
.list-body-enter-from,
.list-body-leave-to {
  opacity: 0;
}

@media screen and (min-width: $cdr-breakpoint-md) {
  .list {
    &__table {
      &-header {
        display: table-header-group;
        th {
          font-size: $cdr-text-body-300-size;

          &:first-child {
            padding-left: $cdr-space-two-x;
          }
        }
      }
    }
  }
}

@media screen and (min-width: $cdr-breakpoint-lg) {
  .list {
    &__text {
      padding-left: $cdr-space-two-x;
      padding-right: $cdr-space-two-x;
    }
  }
}
</style>
